"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _styled = require("./styled");

var _constants = require("./constants");

var _propTypes = require("./propTypes");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var getGridItems = function getGridItems(_ref) {
  var breakpoints = _ref.breakpoints,
      children = _ref.children,
      columns = _ref.columns,
      gutterWidth = _ref.gutterWidth;
  return _react.Children.map(children, function (child) {
    return (0, _react.cloneElement)(child, {
      breakpoints: breakpoints,
      columns: columns,
      gutterWidth: gutterWidth
    });
  });
};

var Grid = function Grid(props) {
  return (0, _core.jsx)(_styled.GridRoot, props, getGridItems(props));
};

Grid.displayName = 'Grid';
var defaultProps = {
  alignItems: _constants.ALIGN_ITEMS.stretch,
  // Same as Flex
  columns: 12,
  gutterWidth: _constants.GUTTER_WIDTH.md // Same as Flex

};
Grid.defaultProps = defaultProps;
Grid.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.gridPropTypes : {};
var _default = Grid;
exports.default = _default;